import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HomePage from "./components/HomePage";
import CreateEnquiry from "./components/CreateEnquiry";
import ListOfEnquiry from "./components/ListOfEnquiry";
import ListOfOrder from "./components/ListOfOrder";
import ListOfReturn from "./components/ListOfReturn";
import ViewReturnRequest from "./components/ViewReturnRequest";
import ViewOrder from "./components/ViewOrder";
import ViewDraft from "./components/ViewDraft";
import ViewEnquiry from "./components/ViewEnquiry";
import ReturnRequest from "./components/ReturnRequest";
import OrderPlacing from "./components/OrderPlacing";
import OrderPlacingStatus from "./components/OrderPlacingStatus";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ViewOrderStatistics from "./components/ViewOrderStatistics";
import Contact from "./components/Contact";
import Help from "./components/Help";
import AppContextProvider from "./context/AppContext";
import ProtectedRoute from "./components/ProtectedRoute";
import StartingPage from "./components/StartingPage";
import ViewEnquiryAfterQuotationGeneration from "./components/ViewEnquiryAfterQuotationGeneration";
import DepartmentWiseSales from "./components/DepartmentWiseSales";
import CreateEnquiryFromDraft from "./components/CreateEnquiryFromDraft";

function App() {
  return (
    // changed <Router /> to <Router basename={process.env.PUBLIC_URL}>
    // because when hosted on gh-pages links like this working only in https://techdeptcubix.github.io/viewOrderStatistics
    // not on  https://techdeptcubix.github.io/premier-web-portal/viewOrderStatistics

    <Router >
      <AppContextProvider>

        <Header />

        <Routes>

          <Route path="/" exact element={<StartingPage />} />


          <Route path="/home" element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          } />

          <Route path="/createEnquiry" element={
            <ProtectedRoute>
              <CreateEnquiry />
            </ProtectedRoute>
          } />


          <Route path="/createEnquiryFromDraft" element={
            <ProtectedRoute>
              <CreateEnquiryFromDraft />
            </ProtectedRoute>
          } />

          <Route path="/listOfEnquiry" element={
            <ProtectedRoute>
              <ListOfEnquiry />
            </ProtectedRoute>
          } />

          <Route path="/listOfOrder" element={
            <ProtectedRoute>
              <ListOfOrder />
            </ProtectedRoute>
          } />

          <Route path="/listOfReturn" element={
            <ProtectedRoute>
              <ListOfReturn />
            </ProtectedRoute>
          } />

          <Route path="/viewReturnRequest" element={
            <ProtectedRoute>
              <ViewReturnRequest />
            </ProtectedRoute>
          } />


          <Route path="/viewOrder" element={
            <ProtectedRoute>
              <ViewOrder />
            </ProtectedRoute>
          } />

          <Route path="/viewDraft" element={
            <ProtectedRoute>
              <ViewDraft />
            </ProtectedRoute>
          } />
          <Route path="/viewEnquiry" element={
            <ProtectedRoute>
              <ViewEnquiry />
            </ProtectedRoute>
          } />

          <Route path="/returnRequest" element={
            <ProtectedRoute>
              <ReturnRequest />
            </ProtectedRoute>
          } />


          <Route path="/orderPlacing" element={
            <ProtectedRoute>
              <OrderPlacing />
            </ProtectedRoute>
          } />

          <Route path="/orderPlacingStatus" element={
            <ProtectedRoute>
              <OrderPlacingStatus />
            </ProtectedRoute>
          } />
          <Route path="/viewOrderStatistics" element={
            <ProtectedRoute>
              <ViewOrderStatistics />
            </ProtectedRoute>
          } />

          <Route path="/department-wise-sales" element={
            <ProtectedRoute>
              <DepartmentWiseSales />
            </ProtectedRoute>
          } />


          <Route path="/help" element={
            <ProtectedRoute>
              <Help />
            </ProtectedRoute>
          } />

          <Route path="/contact" element={
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          } />
          <Route path="/viewEnquiryAfterQuotationGeneration" element={
            <ProtectedRoute>
              <ViewEnquiryAfterQuotationGeneration />
            </ProtectedRoute>
          } />


        </Routes>

        <Footer />
      </AppContextProvider>
    </Router>
  );
}

export default App;
